import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75fa255a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contacts-list" }
const _hoisted_2 = { class: "contacts-list-title" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailTitle = _resolveComponent("DetailTitle")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ListView = _resolveComponent("ListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DetailTitle, {
        title: "联系人管理",
        collapse: _ctx.collapse,
        onCollapse: _ctx.onCollapseChange
      }, null, 8, ["collapse", "onCollapse"]),
      (!_ctx.collapse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.onBuild
            }, {
              default: _withCtx(() => [
                _createTextVNode("新增")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.collapse)
      ? (_openBlock(), _createBlock(_component_ListView, {
          key: 0,
          ref: "list-view",
          "complex-list": _ctx.mainData,
          option: _ctx.listOption
        }, null, 8, ["complex-list", "option"]))
      : _createCommentVNode("", true)
  ]))
}